import React from 'react';
import { AiOutlineLogin, AiOutlineLogout } from 'react-icons/ai';
import {
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Tag,
  TagLabel,
  useColorModeValue,
} from '@chakra-ui/react';
import i18next from 'i18next';
import { useAtom } from 'jotai';

import UserCard from '@/components/0-reusable-components/user-card';
import { meAtom } from '@/store/me.store';
import { colors, zIndexMap } from '@/styles/ui.theme';
import { redirectToSignOut } from '@/utils/services/accounts';

import DescomplicaIcon from '../../../../../assets/svg/descomplica-icon.svg';

const CenterItems = (): React.ReactElement => (
  <HStack spacing={8} alignItems='center'>
    <Box w='32px' h='32px' mr='16px'>
      <DescomplicaIcon />
    </Box>
  </HStack>
);

type UserRoleProps = { label: string };

const UserRole = ({ label }: UserRoleProps): React.ReactElement => (
  <Tag size='sm' colorScheme='descomplica' borderRadius='full'>
    <TagLabel>{label}</TagLabel>
  </Tag>
);

const RightItems = (): React.ReactElement => {
  const [me] = useAtom(meAtom);

  if (!me) {
    return (
      <Flex alignItems='center'>
        <Menu>
          <MenuItem
            icon={<AiOutlineLogin />}
            onClick={() => redirectToSignOut()}>
            {i18next.t('navigationComponent.signout')}
          </MenuItem>
        </Menu>
      </Flex>
    );
  }

  return (
    <Flex alignItems='center'>
      <Menu>
        <MenuButton as={Button} rounded='full' variant='link' cursor='pointer'>
          <Avatar size='sm' name={me.name} src={me.picture} />
        </MenuButton>
        <MenuList>
          <MenuItem>
            <UserCard name={me.name} email={me.email} imgUrl={me.picture} />
          </MenuItem>
          <MenuItem>
            {me.roles.map((role) => (
              <UserRole key={role.name} label={role.name} />
            ))}
          </MenuItem>
          <MenuDivider />
          <MenuItem icon={<AiOutlineLogout />} onClick={() => redirectToSignOut()}>
            {i18next.t('navigationComponent.signout')}
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
};

const SideNavbar = (): React.ReactElement => {
  return (
    <Box
      position='sticky'
      top={0}
      zIndex={zIndexMap.sky}
      bg={useColorModeValue('white', 'gray.900')}
      px={4}
      borderBottom={`1px solid ${colors.descomplica.gray['secondary-gray-30']}`}
    >
      <Flex h={16} alignItems='center' justifyContent='space-between'>
        <CenterItems />
        <RightItems />
      </Flex>
    </Box>
  );
};

export default SideNavbar;
